import { OpenInNewTabIcon } from '@mentimeter/ragnar-visuals';
import * as React from 'react';
import { Clickable } from '@mentimeter/ragnar-ui/clickable';
import { Text } from '@mentimeter/ragnar-ui/text';
import { usePresentationActions } from '../../misc/presentation-actions';
import { useTranslate } from '../../../state/translation';

export const Mentimote = () => {
  const translate = useTranslate();
  const { openMentimote } = usePresentationActions();

  return (
    <Clickable
      aria-label="Open mentimote"
      alignItems="center"
      justifyContent="space-evenly"
      flexDirection="row"
      onClick={openMentimote}
      borderRadius="full"
      px={4}
      py={3}
      color="primary"
      gap="space4"
      extend={() => ({
        opacity: 1,
        '@media (hover: hover)': {
          ':hover': {
            opacity: 1,
          },
        },
      })}
    >
      <Text fontSize={1} fontWeight="semiBold" color="primary">
        {translate('toolbar.open_mentimote')}
      </Text>
      <OpenInNewTabIcon />
    </Clickable>
  );
};
